import { render, staticRenderFns } from "./baptis.vue?vue&type=template&id=40766762&scoped=true&"
import script from "./baptis.vue?vue&type=script&lang=js&"
export * from "./baptis.vue?vue&type=script&lang=js&"
import style0 from "./baptis.vue?vue&type=style&index=0&id=40766762&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40766762",
  null
  
)

export default component.exports